import Repository from '@/app/shared/infrastructure/http/Repository';

export default class ProviderRepository extends Repository {
    uri = '/api/providers';
}
